import { cva } from 'class-variance-authority';

const createContainerClasses = () =>
  cva('grid gap-4 w-full mx-auto justify-items-center transition-all duration-300 ease-in-out', {
    variants: {
      variant: {
        grid: 'grid-cols-2 sm:grid-cols-3 min-[600px]:grid-cols-4 md:grid-cols-5 lg:grid-cols-6',
        list: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 w-full',
      },
      transitioning: {
        true: 'opacity-0 transform scale-95',
        false: 'opacity-100 transform scale-100',
      },
    },
    defaultVariants: {
      variant: 'grid',
      transitioning: false,
    },
  });

const createCardClasses = () =>
  cva('relative transition-all duration-300', {
    variants: {
      variant: {
        grid: 'dark rounded-md h-full w-full hover:scale-110 aspect-136/102',
        list: 'rounded-lg w-full h-full',
      },
    },
    defaultVariants: {
      variant: 'grid',
    },
  });

export { createCardClasses, createContainerClasses };
